import { matchPath } from 'react-router-dom'

/**
 * When your app is using base href or in something other than root of path set this
 *
 * @example example like `/app/routing` which is set as base href, so links like /stats go to /app/routing/stats
 * this app is not in a directory
 */
const context = ''

export const isMatch = (path: string) =>
  matchPath(
    `${path.replace(context || '', '').split('?')[0]}/*`,
    window.location?.pathname.replace(context || '', '')
  ) !== null
